import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Table, TableHeader, TableRow, TableHead, TableBody, TableCell } from "@/components/ui/table";

export default function MyClaims() {
  const [claims, setClaims] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/claims/mine").then(r => setClaims(r.data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <h1 className="font-heading text-3xl sm:text-4xl font-bold text-gray-900">My venue claims</h1>
      <p className="mt-3 text-gray-700">Track the status of any venues you've claimed as an owner.</p>

      <Card className="mt-8 rounded-xl border border-gray-200 overflow-hidden">
        <Table>
          <TableHeader><TableRow>
            <TableHead>Venue</TableHead><TableHead>Note</TableHead><TableHead>Status</TableHead><TableHead>Submitted</TableHead>
          </TableRow></TableHeader>
          <TableBody>
            {loading && <TableRow><TableCell colSpan={4} className="text-center py-6 text-gray-500">Loading…</TableCell></TableRow>}
            {!loading && claims.length === 0 && (
              <TableRow><TableCell colSpan={4} className="text-center py-8 text-gray-500">
                No claims yet — visit a venue page and press "Claim this venue" to get started.
              </TableCell></TableRow>
            )}
            {claims.map(c => (
              <TableRow key={c.id}>
                <TableCell><Link to={`/venue/${c.venue_id}`} className="font-medium hover:underline">{c.venue_name || c.venue_id}</Link></TableCell>
                <TableCell className="text-sm text-gray-700 max-w-md">{c.note}</TableCell>
                <TableCell><Badge variant="outline" className="rounded-full capitalize">{c.status}</Badge></TableCell>
                <TableCell className="text-sm text-gray-500">{new Date(c.created_at).toLocaleDateString()}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Card>

      <div className="mt-6"><Button asChild variant="outline" className="rounded-full border-2 border-gray-900"><Link to="/dashboard">Back to dashboard</Link></Button></div>
    </div>
  );
}
